import { LANGUAGE_KEYS } from 'config/languageKeys';

import { ParentalControlRating, Profile } from 'store/user/reducer.types';

const { PROFILE } = LANGUAGE_KEYS;

const PROFILE_ADD_CHANE_ERROR_DESCRIPTION =
    'PROFILE_ADD_CHANE_ERROR_DESCRIPTION';

const PROFILE_NAME_EXISTING_PROFILE_ERROR =
    'PROFILE_NAME_EXISTING_PROFILE_ERROR';

export const validateProfileName = (name: string) => {
    return name ? '' : PROFILE_ADD_CHANE_ERROR_DESCRIPTION;
};

export const validateProfileNameToExistingNames = (
    newName: string,
    profiles: Profile[],
) => {
    return profiles.some(
        ({ name }) => name.toLowerCase() === newName.toLowerCase(),
    )
        ? PROFILE_NAME_EXISTING_PROFILE_ERROR
        : '';
};

export const standardAgeRatingItemSubtitle = {
    [ParentalControlRating.HU_GENERAL]: PROFILE['PROFILE_AGE_RATING_6+'],
    [ParentalControlRating.UNKNOWN]: PROFILE['PROFILE_AGE_RATING_6+'],
    [ParentalControlRating.HU_UNRATED]: PROFILE['PROFILE_AGE_RATING_6+'],
    [ParentalControlRating.HU6]: PROFILE['PROFILE_AGE_RATING_6+'],
    [ParentalControlRating.HU12]: PROFILE['PROFILE_AGE_RATING_12+'],
    [ParentalControlRating.HU16]: PROFILE['PROFILE_AGE_RATING_16+'],
    [ParentalControlRating.HU18]: PROFILE['PROFILE_AGE_RATING_18+'],
    [ParentalControlRating.HU18_ADULT_CENSORED]:
        PROFILE.PROFILE_AGE_RATING_CENSORED,
    [ParentalControlRating.HU18_ADULT_UNCENSORED]:
        PROFILE.PROFILE_AGE_RATING_UNCENSORED,
};

export const kidsRatingItemSubtitle = {
    [ParentalControlRating.HU_GENERAL]: PROFILE.PROFILE_AGE_RATING_DROPDOWN_0_5,
    [ParentalControlRating.UNKNOWN]: PROFILE.PROFILE_AGE_RATING_DROPDOWN_0_5,
    [ParentalControlRating.HU_UNRATED]: PROFILE.PROFILE_AGE_RATING_DROPDOWN_0_5,
    [ParentalControlRating.HU6]: PROFILE.PROFILE_AGE_RATING_DROPDOWN_6_11,
    [ParentalControlRating.HU12]: PROFILE.PROFILE_AGE_RATING_DROPDOWN_12_MORE,
    [ParentalControlRating.HU16]: '',
    [ParentalControlRating.HU18]: '',
    [ParentalControlRating.HU18_ADULT_CENSORED]: '',
    [ParentalControlRating.HU18_ADULT_UNCENSORED]: '',
};
